import React, { useState } from 'react';
import { ImageCard, ServiceDetails } from '../../components';
import './index.css';

interface ImageData {
  id: number;
  src: string;
  title: string;
  description: string;
}

const imageData: ImageData[] = [
  {
    id: 1,
    src: '/images/office_5.jpeg',
    title: 'Image 1',
    description: 'Description 1',
  },
  {
    id: 2,
    src: '/images/office_4.jpeg',
    title: 'Image 2',
    description: 'Description 2',
  },
  {
    id: 3,
    src: '/images/office_3.jpeg',
    title: 'Image 3',
    description: 'Description 3',
  },
  {
    id: 4,
    src: '/images/office_1.jpeg',
    title: 'Image 4',
    description: 'Description 4',
  },
  {
    id: 5,
    src: '/images/office_2.jpeg',
    title: 'Image 5',
    description: 'Description 5',
  },
  {
    id: 6,
    src: '/images/office_3.jpeg',
    title: 'Image 6',
    description: 'Description 6',
  },
  {
    id: 7,
    src: '/images/office_4.jpeg',
    title: 'Image 7',
    description: 'Description 7',
  },
  {
    id: 8,
    src: '/images/office_5.jpeg',
    title: 'Image 8',
    description: 'Description 8',
  },
];

export const Services = () => {
  const shouldSpanTwoColumns = (index: number) => {
    const row = Math.floor(index / 2);
    const positionInRow = index % 2;

    return (
      (row % 2 === 0 && positionInRow === 0) ||
      (row % 2 !== 0 && positionInRow === 1)
    );
  };

  return (
    <div className="container" style={{ padding: '550px' }}>
      {' '}
      {/* Add padding directly */}
      <div className="grid-container">
        {imageData.map((image, index) => (
          <ImageCard
            key={image.id}
            image={image}
            spanTwoColumns={shouldSpanTwoColumns(index)}
          />
        ))}
      </div>
    </div>
  );
};
